import { Component } from "react"
import classNames from "classnames"
import PropTypes from "prop-types"

class LegendItem extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onlyLegendText: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    focus: PropTypes.func.isRequired,
    blur: PropTypes.func.isRequired,
    onOnlyToggle: PropTypes.func.isRequired,
    focused: PropTypes.string,
  }

  onClick = () => {
    const { id, onClick } = this.props
    onClick(id)
  }

  onEnter = () => {
    const { id, focus, disabled } = this.props
    !disabled && focus(id)
  }

  onLeave = () => {
    const { blur, disabled } = this.props
    !disabled && blur()
  }

  toggleOnly = () => {
    const { id, onOnlyToggle, onlyLegendText } = this.props
    onOnlyToggle(id, onlyLegendText)
  }

  render() {
    const { color, label, disabled, focused, id, onlyLegendText } = this.props
    return <div
      onMouseEnter={this.onEnter}
      onMouseLeave={this.onLeave}
      className={classNames(
        "focus-enabled",
        focused && focused === id && "visible",
        focused && focused !== id && "hidden",
      )}
    >
      <div onClick={this.onClick}>
        <div
          className={classNames("color", disabled && "color--disabled")}
          style={{
            borderColor: color,
            ...(!disabled && { backgroundColor: color }),
          }}
        />
        <div className="label" title={label}>{label}</div>
      </div>
      <div
        onClick={this.toggleOnly}
        style={{ color }}
        className={classNames(
          "only-link",
          focused && focused === id && "visible",
          focused && focused !== id && "hidden",
        )}
      >
        {onlyLegendText}
      </div>
    </div>
  }
}

export default LegendItem
